<template>
  <v-dialog v-model="open" max-width="80%" scrollable @click:outside="hide">
    <v-card>
			<v-card-title class="title primary--text secondary">
        <translate>TCM Test</translate><span class="mx-1">-</span><translate>Abdominal Palpation</translate>
      </v-card-title>
			<v-card-text class="pt-4">
        <v-form ref="form">
					<v-row no-gutters>
						<v-col cols="12">
							<v-textarea
								v-model="test.data.note"
								:label="$gettext('Note')"
								class="px-2"
								outlined
								:disabled="results"
                :rules="[required]"
							/>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
      <v-divider></v-divider>
			<v-card-actions>
				<v-btn v-if="results" color="primary darken-1" text @click="hide">
					<translate>Close</translate>
				</v-btn>
				<v-btn v-else color="primary darken-1" text @click="hide">
					<translate>Cancel</translate>
				</v-btn>
				<v-spacer></v-spacer>
				<v-btn v-if="!edit && !results" color="primary darken-1" text @click="submitTest">
					<translate>Create</translate>
				</v-btn>
				<v-btn v-if="edit" color="primary darken-1" text @click="editTest">
					<translate>Save</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TCMAbdominalPalpationForm",
  props: {
		test: {
			default: () => ({
				kind: "abdominal-palpation",
        module: "tcm",
        data: {
          note: null
        }
			})
		},
		edit: {
			default: false
		},
		results: {
			default: false
		}
  },
  data: () => ({
    open: true
  }),
  computed: {
    required() {
			return value => !!value || this.$gettext("Required.");
		}
  },
  methods: {
    validateForm() {
      return this.$refs.form.validate();
    },
    submitTest() {
      if(this.validateForm()) {
        const formData = new FormData();
        formData.append("info", JSON.stringify(this.test.data));
        formData.append("kind", "abdominal-palpation");
        formData.append("module", "tcm");
        this.$emit("create-test", formData);
        this.hide();
      }
		},
		editTest() {
      if(this.validateForm()) {
        const formData = new FormData();
        formData.append("info", JSON.stringify(this.test.data));
        formData.append("kind", "abdominal-palpation");
        formData.append("module", "tcm");
        this.$emit("edit-test", formData);
        this.hide();
      }
		},
		hide() {
			this.$emit("hide");
		}
  }
}
</script>